import { render } from "./PlayerSettings.vue?vue&type=template&id=24e86faa&scoped=true"
import script from "./PlayerSettings.vue?vue&type=script&lang=js"
export * from "./PlayerSettings.vue?vue&type=script&lang=js"

import "./PlayerSettings.vue?vue&type=style&index=0&id=24e86faa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24e86faa"]])

export default __exports__